import React, { useEffect } from "react";
import {
  getApplication,
  getManagedResourceTypesInApplication,
  getServiceCollection,
} from "../../actions/api";
import { Breadcrumb, List, Space, Typography } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ManagedResourcesListAdmin from "./ManagedResourcesListAdmin";
import { useParams } from "react-router";
import { ApplicationHeader, ServiceHeader } from "../headers/PageHeaders";
import { NavLink } from "react-router-dom";

const { Title } = Typography;

const ManagedResourceTypesListAdmin = ({
  getManagedResourceTypesInApplication,
  managedResourceTypes,
  isLoading,
  getApplication,
  application,
  getServiceCollection,
  serviceCollection,
}) => {
  const { serviceCollectionId, applicationId } = useParams();

  useEffect(() => {
    getServiceCollection(serviceCollectionId);
  }, [getServiceCollection, serviceCollectionId]);

  useEffect(() => {
    getApplication(applicationId);
    getManagedResourceTypesInApplication(applicationId);
  }, [getApplication, getManagedResourceTypesInApplication, applicationId]);

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: <NavLink to="/manage">Service Collections</NavLink>,
          },
          {
            title: (
              <NavLink to={`/manage/${serviceCollectionId}`}>
                Service Applications for {serviceCollectionId}
              </NavLink>
            ),
          },
          {
            title: `Managed Resources for ${applicationId}`,
          },
        ]}
      />
      <ServiceHeader
        title={serviceCollection?.displayName}
        subTitle={serviceCollection?.description}
        loading={isLoading}
      />
      <ApplicationHeader title={application?.displayName} />
      <Title
        level={5}
        style={{ marginTop: "0px", padding: "5px", border: "solid 1px #ddd" }}
      >
        Resources attached to this Service Application, grouped by Managed
        Resource Types
      </Title>
      <Space direction="vertical">
        <List
          grid={{ gutter: 16, column: 1 }}
          loading={isLoading}
          dataSource={managedResourceTypes}
          renderItem={(item) => (
            <List.Item>
              <ManagedResourcesListAdmin
                key={item.id}
                managedResourceTypeName={item.resourceTypeName}
              />
            </List.Item>
          )}
          locale={{
            emptyText:
              "No Resource Types you are allowed to manage were found.",
          }}
        />
      </Space>
    </div>
  );
};

ManagedResourceTypesListAdmin.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  getManagedResourceTypesInApplication: PropTypes.func,
  managedResourceTypes: PropTypes.array,
  getApplication: PropTypes.func,
  application: PropTypes.object,
  getServiceCollection: PropTypes.func,
  serviceCollection: PropTypes.object,
};

export default connect(
  (state) => ({
    managedResourceTypes: state.managedResourceTypes.data,
    isLoading: state.managedResourceTypes.loading,
    application: state.application.data,
    serviceCollection: state.serviceCollection.data,
  }),
  {
    getManagedResourceTypesInApplication,
    getApplication,
    getServiceCollection,
  },
)(ManagedResourceTypesListAdmin);
